import React from 'react';
import {
  Modal, Body, Theme,
} from '@routific/hive';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../store/mst';
import Checkbox from '../../shared/Checkbox';
import ReoptimizeConfirmModalFooter from './ReoptimizeConfirmModalFooter';

interface Props {
  visible: boolean,
  onReoptimize: () => void;
  onBestInsert?: () => void;
  onCancel: () => void;
  reoptimizeButton?: boolean,
  numRoutes?: number,
}

const ReoptimizeConfirmModal: React.FC<Props> = ({
  visible, onReoptimize, onBestInsert, onCancel, reoptimizeButton = false, numRoutes,
}) => {
  const { t } = useTranslation('components');
  const store = useStore();

  const handleCheckboxChange = (checked: boolean) => {
    store.ui.setDisableConfirmReoptimizeModal(checked);
  };

  return (
    <Modal
      size="small"
      centered
      visible={visible}
      title={t('reoptimizeRouteConfirmModal.title', { count: numRoutes })}
      data-cy='reoptimize-confirm-modal'
      onCancel={onCancel}
      footer={
        <ReoptimizeConfirmModalFooter
          onReoptimize={onReoptimize}
          onBestInsert={onBestInsert}
          onCancel={onCancel}
          reoptimizeButton={reoptimizeButton}
        />
      }
      destroyOnClose
    >
      <Body>
        {reoptimizeButton ? t('unscheduledVisits.confirm.text') : t('reoptimizeRouteConfirmModal.text')}
      </Body>
      {reoptimizeButton && (
        <Checkbox
          onChange={handleCheckboxChange}
          label={t('common:disableShowAgain')}
          sx={{ marginTop: Theme.Spacing.mdSpacing }}
        />
      )}
    </Modal>
  );
};

export default ReoptimizeConfirmModal;
